var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-user-data"},[_c('div',{staticClass:"header-user-data__name"},[_vm._v(_vm._s(_vm.username))]),_c('div',{staticClass:"header-user-data__email"},[_vm._v(_vm._s(_vm.email))])])}
var staticRenderFns = []

export { render, staticRenderFns }